<script>
  import { fade } from 'svelte/transition';
  import Collapsible from './Collapsible.svelte';
  import Leaderboard from './Leaderboard.svelte';
  import { categories, races, selectedRaceId, raceResultsStore as data } from '../stores';

  let styles = "letter-spacing: 2px; background-color:#FFFFFF;color:#b2b2b2; border-bottom: 1px solid black; font-weight:900; font-size: 1.2rem;";

  function getRaceInfo(raceId) {
    let array = $races.filter(item => item.id == raceId);
    let raceInfo;
    if (array.length > 0) {
      raceInfo = array[0];
      return raceInfo;
    } 
  }

  let raceInfo = getRaceInfo($selectedRaceId);
  let tempArray = JSON.parse(JSON.stringify($data));
  let participants = tempArray.filter(item => item.ri == $selectedRaceId);
  let filteredList;
</script>
<div in:fade="{{delay: 250, duration: 300}}" class="pt-2" style="background-color: #F0EFF0;">
  <div class="card border-dark mx-2 mt-2 mb-3 text-start">
    <div class="card-header container-background" style="background-color:{raceInfo.color}">RACE {raceInfo.id}</div>
    <div class="card-body text-dark">
      <h3 class="card-title">{raceInfo.name}</h3>
      <p class="card-text">{raceInfo.location}</p>
      <p class="card-text"><strong>{raceInfo.date}</strong></p>
    </div>
  </div>
  <section>
    <Collapsible headerText={ "Overall" } ridersInCategory={ participants.length } headerStyle={styles} strokeStyle="black">
      <div class="content px-0 py-0" style="background-color:white;">
        <Leaderboard categoryId={ 0 } participants={participants} />
      </div>
    </Collapsible>
    {#each $categories as {id, name}}
    <div style="display: none;">
      {
        filteredList = participants.filter(item => item.ci == id)
      } 
    </div>
      <Collapsible headerText={ name } ridersInCategory={ filteredList.length } headerStyle={styles} strokeStyle="black">
        <div class="content px-0 py-0" style="background-color:white;">
          <Leaderboard categoryId={ id } participants={filteredList} />
        </div>
      </Collapsible>
    {/each}
  </section>
</div>
<style>
	section {
		width: 100%;
	}
	
	.content {
		background-color: #f4f4f4;
		padding: 0.5em;
	}
</style>